import { CFAuthGetRef } from 'auth';
import { locations } from "../../common/redux/action_locations";
import moment from "moment-timezone";
import {
	FETCH_TIME_OFF_ENUM,
	RECEIVED_TIME_OFF_ENUM,
	FETCH_REQUEST_STATUS_ENUM,
	RECEIVED_REQUEST_STATUS_ENUM,
	FETCH_CURRENT_REQUESTS, 
	RECEIVED_CURRENT_REQUESTS,
	DATETIME_FORMAT,
	RECEIVED_APPROVED_REQUESTS,
	FETCH_NOTIFICATION_TYPE_ENUM,
	FILTER_REQUESTS,
	RECEIVED_NOTIFICATION_TYPE_ENUM
} from "./constants";

export function fetchTimeOffEnumAction() {
	return {
        type: FETCH_TIME_OFF_ENUM,
        fetchCall: fetchTimeOffEnum,
        receivedAction: receivedTimeOffEnum,
        data: {
            locations
        }
    };
}

function fetchTimeOffEnum(parameters) {
	return CFAuthGetRef({
		url: process.env.REACT_APP_AP_API_URL + '/Enum/TimeoffType/',
		params: null,
		originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchTimeOffEnum'
	});
}

export function receivedTimeOffEnum(data) {
	return {
        type: RECEIVED_TIME_OFF_ENUM,
        TimeOffEnumItems: data
	};
}

export function fetchRequestStatusEnumAction() {
	return {
        type: FETCH_REQUEST_STATUS_ENUM,
        fetchCall: fetchRequestStatusEnum,
        receivedAction: receivedRequestStatusEnum,
        data: {
            locations
        }
    };
}

function fetchRequestStatusEnum() {
	return CFAuthGetRef({
		url: process.env.REACT_APP_AP_API_URL + '/Enum/RequestStatus/',
		params: null,
		originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchRequestStatusEnum'
	});
}

export function receivedRequestStatusEnum(data) {
	return {
        type: RECEIVED_REQUEST_STATUS_ENUM,
        RequestStatusEnumItems: data
	};
}

export function fetchNotificationTypeEnumAction() {
	return {
        type: FETCH_NOTIFICATION_TYPE_ENUM,
        fetchCall: fetchNotificationTypeEnum,
        receivedAction: receivedNotificationTypeEnum,
        data: {
            locations
        }
    };
}

function fetchNotificationTypeEnum() {
	return CFAuthGetRef({
		url: process.env.REACT_APP_AP_API_URL + '/Enum/NotificationType/',
		params: null,
		originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchNotificationTypeEnum'
	});
}

export function receivedNotificationTypeEnum(data) {
	return {
        type: RECEIVED_NOTIFICATION_TYPE_ENUM,
        notificationTypeEnumItems: data
	};
}

export function fetchCurrentRequestsAction(filters, isApprovedWidgetCall=false) {
	if(!isApprovedWidgetCall)
		return {
			type: FETCH_CURRENT_REQUESTS,
			fetchCall: fetchCurrentRequests,
			receivedAction: receivedCurrentRequests,
			data: {
				locations,
				filters
			}
		};

	return {
		type: FETCH_CURRENT_REQUESTS,
		fetchCall: fetchCurrentRequests,
		receivedAction: receivedApprovedRequests,
		data: {
			locations,
			filters
		}
	};
}

export function fetchCurrentRequests(filters) {
	let customQueryParams = filters;
	let customQueryParamsFilter = filters.customFilters;

	let customFilterParams = "";
	if (customQueryParamsFilter && Object.keys(customQueryParamsFilter).length > 0) {
		
		Object.keys(customQueryParamsFilter).forEach(function (paramKey, firstLevelIndex) {
		
			let currentItem = customQueryParamsFilter[paramKey];
			customFilterParams = customFilterParams + "&" + Object.keys(currentItem).map(function (paramKey2) {

				let formattedKey = `FilterConditions[${firstLevelIndex}].${paramKey2}`;
				return formattedKey + "=" + currentItem[paramKey2];
			}).join("&");
		});
	}

	return CFAuthGetRef({
        url: process.env.REACT_APP_AP_API_URL + '/TimeoffRequest/',
        params: {
            Page: customQueryParams.Page,
            PageSize: customQueryParams.PageSize,
            SortOrder: customQueryParams.SortOrder,
            SortColumn: customQueryParams.SortColumn
        },
        customQueryParams: customFilterParams,
        originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchCurrentRequests'
	});
}


export function receivedCurrentRequests(data) {
    
	let uiModelData = [];
	if(data.items && data.items.length > 0) {

	    data.items.forEach((item, index) => {
			uiModelData.push ({
				id: item.id,
				timeoffRequestId: item.timeoffRequestId,
				timeoffType: item.timeoffType,
				timeoffValue: item.timeoffValue,
				requestStatus: item.requestStatus,
				ptoBalance: item.ptoBalance !== null ? item.ptoBalance.toFixed(2) : 0,
				agentId: item.agentId,
				agentName: item.agentName,
				supervisorId: item.supervisorId,
				supervisorName: item.supervisorName,
				startDate: moment(item.startDate).format(DATETIME_FORMAT),
				endDate: moment(item.endDate).format(DATETIME_FORMAT),
				dateRange: item.dateRange,
				totalHours: item.totalHours,
				timeoffReason: item.timeoffReason,
				dateCreated: moment(item.dateCreated).format(DATETIME_FORMAT),
				dateUpdated: item.dateUpdated,
				createdBy: item.createdBy,
				updatedBy: item.updatedBy
			});
		});
	}

	return {
		type: RECEIVED_CURRENT_REQUESTS,
		CurrentRequests: uiModelData
	};
}

function receivedApprovedRequests(data) {
    
	let uiModelData = [];
	if(data.items && data.items.length > 0) {

		data.items.forEach((item, index) => {
			uiModelData.push ({
				id: item.id,
				timeoffRequestId: item.timeoffRequestId,
				timeoffType: item.timeoffType,
				timeoffValue: item.timeoffValue,
				requestStatus: item.requestStatus,
				ptoBalance: item.ptoBalance,
				agentId: item.agentId,
				agentName: item.agentName,
				supervisorId: item.supervisorId,
				supervisorName: item.supervisorName,
				startDate: moment(item.startDate).format(DATETIME_FORMAT),
				endDate: moment(item.endDate).format(DATETIME_FORMAT),
				totalHours: item.totalHours,
				timeoffReason: item.timeoffReason,
				dateCreated: moment(item.dateCreated).format(DATETIME_FORMAT),
				dateUpdated: item.dateUpdated,
				createdBy: item.createdBy,
				updatedBy: item.updatedBy
			});
		});
	}

    return {
        type: RECEIVED_APPROVED_REQUESTS,
        approvedRequests: uiModelData
	};
}

export function filterRequestsAction(filteredRequests) {
	return {
		type: FILTER_REQUESTS,
		FilteredRequests: filteredRequests
	}
}

export function reducer(state, action) {
	switch (action.type) {
		case RECEIVED_TIME_OFF_ENUM:
        return {
            ...state,
            TimeOffEnumItems: action.TimeOffEnumItems,
		};
		case RECEIVED_REQUEST_STATUS_ENUM:
        return {
            ...state,
            RequestStatusEnumItems: action.RequestStatusEnumItems,
		};
		case RECEIVED_NOTIFICATION_TYPE_ENUM:
        return {
            ...state,
            notificationTypeEnumItems: action.notificationTypeEnumItems,
		};
		case RECEIVED_CURRENT_REQUESTS:
		return {
            ...state,
			CurrentRequests: action.CurrentRequests,
			FilteredRequests: action.CurrentRequests
		};
		case RECEIVED_APPROVED_REQUESTS:
		return {
            ...state,
            approvedRequests: action.approvedRequests,
		};	
		case FILTER_REQUESTS:
		return {
            ...state,
			FilteredRequests: action.FilteredRequests
		};
		default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/features/timeoff/redux/time_off_actions.js